import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    loading: false,
    data: null,
    error: null,
    tcList: null,
    startTimer: null,
    stopTimer: null,
    meetingList: null,
    employeeChart: null,
    absentList: null,
    hrAttendance: null,
    hrAttendanceLoading: false,
    hrAttendanceError: null,
}


export const GetDashboard = createAsyncThunk(
    "GetDashboard",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.get("/crm/dashboard/analytics", {
                timeout: 15000,
            });

            return response?.data;
        } catch (error) {
            if (!error?.response) {
                return rejectWithValue({
                    errorType: "network",
                    message: error?.networkMessage || "Unable to connect. Please check your internet connection.",
                    toastShown: Boolean(error?.networkToastShown),
                })
            }

            return rejectWithValue(error.response?.data || {
                errorType: "server",
                message: "Unable to load dashboard data. Please try again.",
            })
        }
    })

export const fetchHrAttendance = createAsyncThunk(
    "dashboard/fetchHrAttendance",
    async ({ start_date, end_date }, { rejectWithValue }) => {
        try {
            const response = await instance.get("/crm/dashboard/hr-attendance", {
                params: { start_date, end_date },
                timeout: 30000,
            });
            return response?.data?.data;
        } catch (error) {
            return rejectWithValue(
                error?.response?.data || {
                    status: "error",
                    message: "Unable to load biometric attendance.",
                },
            );
        }
    },
)
export const getMeetingList = createAsyncThunk(
    "getMeetingList",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.get(`/crm/events/fetch-my-event?filter=${body.filter}`);
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response)
        }
    })

export const sortTelecallers = createAsyncThunk(
    'sortTelecallers',
    async () => {
        try {
            const response = await instance.get('/crm/leads/top-list-telecaller');
            return response?.data
        }
        catch (error) {
            return error
        }
    }
)

// {Performance chart api}
export const fetchEmployeePerformance = createAsyncThunk(
    'fetchEmployeePerformance',
    async (body) => {
        try {
            const response = await instance.get(`/crm/employees/fetch-employee-performance?start_date=${body.start_date}&end_date=${body.end_date}`);
            return response?.data
        }
        catch (error) {
            return error
        }
    }
)



// export const fetchTeamMemberAbsent = createAsyncThunk(
//     'fetchTeamMemberAbsent',
//     async (body) => {
//         try {
//             const response = await instance.get(`/crm/employees/fetch-employee-performance`);
//             return response?.data
//         }
//         catch (error) {
//             return error
//         }
//     }
// )


// export const startTaskTimer = createAsyncThunk(
//     'startTaskTimer',
//     async (id) => {
//         try {
//             const response = await instance.post('/crm/tasks/start-task-timer', { task_id: id });
//             return response?.data
//         }
//         catch (error) {
//             return error
//         }
//     }
// )

// export const stopTaskTimer = createAsyncThunk(
//     'stopTaskTimer',
//     async (id) => {
//         try {
//             const response = await instance.post('/crm/tasks/stop-task-timer', { task_id: id });
//             return response?.data
//         }
//         catch (error) {
//             return error
//         }
//     }
// )

export const DashboardSlice = createSlice({
    name: "dashboard",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(GetDashboard.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(GetDashboard.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(GetDashboard.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || {
                errorType: "unknown",
                message: action.error?.message || "Unable to load dashboard data.",
            };
        })
        builder.addCase(fetchHrAttendance.pending, (state) => {
            state.hrAttendanceLoading = true;
            state.hrAttendanceError = null;
        })
        builder.addCase(fetchHrAttendance.fulfilled, (state, action) => {
            state.hrAttendanceLoading = false;
            state.hrAttendance = action.payload;
        })
        builder.addCase(fetchHrAttendance.rejected, (state, action) => {
            state.hrAttendanceLoading = false;
            state.hrAttendanceError = action.payload || {
                status: "error",
                message: "Unable to load biometric attendance.",
            };
        })
        builder.addCase(getMeetingList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getMeetingList.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.meetingList = action.payload;
        });
        builder.addCase(getMeetingList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.meetingList;
        })


        builder.addCase(sortTelecallers.pending, (state) => {
            state.loading = true;
        })

        builder.addCase(sortTelecallers.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.tcList = action.payload;
        })
        builder.addCase(sortTelecallers.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.data;
        })
        builder.addCase(fetchEmployeePerformance.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(fetchEmployeePerformance.fulfilled, (state, action) => {
            state.loading = false;
            state.employeeChart = action.payload;
        })
        builder.addCase(fetchEmployeePerformance.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })

        //        builder.addCase(fetchTeamMemberAbsent.pending, (state) => {
        //     state.loading = true;
        // })
        // builder.addCase(fetchTeamMemberAbsent.fulfilled, (state, action) => {
        //     state.loading = false;
        //     state.absentList = action.payload;
        // })
        // builder.addCase(fetchTeamMemberAbsent.rejected, (state, action) => {
        //     state.loading = false;
        //     state.error = action.payload;
        // })




        // builder.addCase(startTaskTimer.pending, (state) => {
        //     state.loading = true;
        // })

        // builder.addCase(startTaskTimer.fulfilled, (state, action) => {
        //     state.loading = false;
        //     state.error = null;
        //     state.startTimer = action.payload;
        // })
        // builder.addCase(startTaskTimer.rejected, (state, action) => {
        //     state.loading = false;
        //     state.error = action.payload.data;
        // })

        // builder.addCase(stopTaskTimer.pending, (state) => {
        //     state.loading = true;
        // })

        // builder.addCase(stopTaskTimer.fulfilled, (state, action) => {
        //     state.loading = false;
        //     state.error = null;
        //     state.stopTimer = action.payload;
        // })
        // builder.addCase(stopTaskTimer.rejected, (state, action) => {
        //     state.loading = false;
        //     state.error = action.payload.data;
        // })
    }

})

export default DashboardSlice.reducer;
